import Script from 'next/script'
import { FunctionComponent } from 'react'
import logger from '@/utils/logger'

const InstagramEmbedScript: FunctionComponent = () => {
  return (
    <Script
      async
      src='https://www.instagram.com/static/bundles/metro/EmbedSDK.js/33cd2c5d5d59.js'
      onError={(): void => {
        logger.error(new Error('Instagram embed script load fail: onError'))
      }}
    />
  )
}

export default InstagramEmbedScript
